import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { User } from '../models';
import {CaregiverService, PatientService, UserService} from '../services';
import { Router }  from "@angular/router";
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';

@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('menu') menu;
  public isCollapsed: boolean;
  private subscription: Subscription;
  public currentUser: User;
  public avatar;

  constructor(
    private userService: UserService,
    public translate: TranslateService,
    private eRef: ElementRef,
    public router: Router,
    private patientService: PatientService,
    public caregiverService: CaregiverService
  ) {
    translate.addLangs(['en', 'pl', 'de', 'cs', 'fr', 'pt', 'it', 'ro', 'da', 'ar', 'bg', 'no']);

    if (window.localStorage['lang']) {
      translate.use(window.localStorage['lang']);
    } else {
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/en|pl|de|cs|fr|pt|it|ro|da|ar|bg|no/) ? browserLang : 'en');
    }


    this.isCollapsed = true;
  }


  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (Object.keys(userData).length > 0) {
          this.patientService.getAvatar(userData.user_id.id).subscribe(data => {
            console.log('data:' + data);
            this.avatar = data;
          });
        }
      }
    );

    this.subscription = Observable.fromEvent(document, 'click').subscribe((event: KeyboardEvent) => {
      if (!this.isCollapsed) {
        if (!this.eRef.nativeElement.contains(event.target)) {
          this.closeMenu();
        }
      }
    });
  }

  public changeLanguage(lang: string): void {
    this.translate.use(lang);
    window.localStorage['lang'] = lang;
  }

  public closeMenu(): void {
    if (!this.isCollapsed) {
      this.isCollapsed = true;
    }
  }

  public ifContainsStart(text){
    return !(text.includes('/start') || text.includes('/indiv-client/add-user') || text.includes('/indiv-client/accept-documents'));

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout() {
    if (this.currentUser.role === 'ROLE_API_CAREGIVER') {
      this.caregiverService.setTelecare(4).subscribe(() => {
      }, error => {}, () => { this.purgeAuth(); });
    } else {
      this.purgeAuth();
    }
  }

  purgeAuth() {
    this.userService.logout().subscribe(
      data => {
        this.userService.purgeAuth();
        this.router.navigateByUrl('/auth/login').then(() => {
          window.location.reload(true);
        });
      },
      err => {
        this.userService.purgeAuth();
        this.router.navigateByUrl('/auth/login').then(() => {
          window.location.reload(true);
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts